import { useEffect } from 'react';
import { FileTransferCapability } from '@doxyme/extensions-bridge';
import { useAddCapability } from '@doxyme/extensions-bridge-react';
import { bridge } from '../../../features/extensions/instances';
import { useAppDispatch } from '../../../hooks/useReduxToolkit';
import { openModal } from '../../../features/modals/modals.slice';
import { ModalId } from '../../../features/modals/modals.type';

/**
 * Hook responsible for providing file transfer service access to the Extensions SDK
 */
export function useExtensionsFileTransfer(): void {
  const dispatch = useAppDispatch();
  const fileTransfer = useAddCapability(
    bridge,
    () => new FileTransferCapability(),
  );

  useEffect(() => {
    const unsubscribeFromStart = fileTransfer.onStart(
      (): void => void dispatch(openModal(ModalId.FileTransfer)),
    );

    return () => {
      unsubscribeFromStart();
    };
  }, []);
}
